// API Reference: https://www.wix.com/velo/reference/api-overview/introduction
// “Hello, World!” Example: https://learn-code.wix.com/en/article/1-hello-world

import wixLocation from 'wix-location';
import { sendComplaintToKZD } from 'backend/complaint';
import moment from 'moment';
import { local } from 'wix-storage';

let robot = true;

$w.onReady(function () {
    $w('#captcha').onVerified(() => {
        robot = false;
    });
});

export function sendFinishedCase_click(event) {
    $w('#loader').expand();

    let rulesCheck = $w('#rulesCheck').checked;

    if (robot) {
        $w('#error').text = 'Трябва да потвърдите, че не сте робот!';
        $w('#error').expand();
        $w('#loader').collapse();
        return;
    }

    if (!rulesCheck) {
        $w('#error').text = 'Трябва да се съгласите с общите условия, за да продължите!';
        $w('#error').expand();
        $w('#loader').collapse();
        return;
    }

    if (!$w('#error').collapsed) {
        $w('#error').collapse();
        $w('#error').text = 'Моля, попълнете полетата в червено, за да продължите!';
    }

    let data = {
        reasonField: $w('#reason'),
        other: $w('#other'),
        nameFrom: $w('#nameFrom'),
        egnFrom: $w('#egnFrom'),
        cityFrom: $w('#cityFrom'),
        regionFrom: $w('#regionFrom'),
        municipalityFrom: $w('#municipalityFrom'),
        addressFrom: $w('#addressFrom'),
        blockFrom: $w('#blockFrom'),
        entranceFrom: $w('#entranceFrom'),
        floorFrom: $w('#floorFrom'),
        telephoneFrom: $w('#telephoneFrom'),
        against: $w('#against'),
        facts: $w('#facts'),
        proof1: $w('#proof1'),
        proof2: $w('#proof2'),
        proof3: $w('#proof3'),
        proof4: $w('#proof4'),
        witnessName: $w('#witnessName'),
        witnessEgn: $w('#witnessEgn'),
        witnessCity: $w('#witnessCity'),
        witnessRegion: $w('#witnessRegion'),
        witnessMunicipality: $w('#witnessMunicipality'),
        witnessAddress: $w('#witnessAddress'),
        witnessBlock: $w('#witnessBlock'),
        witnessEntrance: $w('#witnessEntrance'),
        witnessFloor: $w('#witnessFloor'),
        dateToSign: $w('#dateToSign'),
        cityToSign: $w('#cityToSign'),
    }

    let reason = [];

    Object.entries(data).map(item => {
        // console.log(item[0], item[1].value);
        if (!item[1].value) {
            item[1].updateValidityIndication();
            if (!item[1].valid) {
                if ($w('#error').collapsed) {
                    $w('#error').expand();
                    $w('#loader').collapse();
                }
            }

        } else {
            if (item[0] === 'other') {
                reason.push(item[1].value);
                if (!$w('#error').collapsed) {
                    data.reasonField.resetValidityIndication();
                    $w('#error').collapse();
                }
            } else if ((item[0] === 'reasonField') && (data.reasonField.value.length > 0)) {
                Array.prototype.push.apply(reason, item[1].value);
            } else if (item[0] === 'reasonField') {
                item[1].updateValidityIndication();
                $w('#error').expand();
                $w('#loader').collapse();
            }
        }
    });

    if (!$w('#error').collapsed) {
        return;
    }


    const momentDate = moment(data.dateToSign.value);
    let formatedDate = momentDate.format("YYYY-MM-DD HH:MM:SS");

    sendComplaintToKZD(data.nameFrom.value, data.egnFrom.value, data.cityFrom.value, data.regionFrom.value, data.municipalityFrom.value, data.addressFrom.value,
            data.blockFrom.value, data.entranceFrom.value, data.floorFrom.value, data.telephoneFrom.value, reason, data.against.value, data.facts.value, data.proof1.value,
            data.proof2.value, data.proof3.value, data.proof4.value, data.witnessName.value, data.witnessEgn.value, data.witnessCity.value, data.witnessRegion.value, data.witnessMunicipality.value,
            data.witnessAddress.value, data.witnessBlock.value, data.witnessEntrance.value, data.witnessFloor.value, formatedDate, data.cityToSign.value)
        .then(response => {
            console.log('res', response);
            $w('#loader').collapse();
            if (response.error) {
                throw new Error(response.error.message);
            }
            local.setItem('filePath', response.filePath);
            local.setItem('fileName', response.fielName);
            local.setItem('complaint', 'kzd');

            wixLocation.to('/petition-success');
        }).catch(error => {
            $w('#loader').collapse();
            if (error.message === 'REQUIRED_FIELDS') {
                $w('#error').expand();
            }
        });

}